import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment.dev";
import { BaseService } from "../../@core/services/base.service";
import { IShareContract, IShareUser, IUser, SHARE_ACCESS, SHARE_FEATURE } from "../../@core/models/model";

@Injectable({ providedIn: 'root', })
export class ShareContractService extends BaseService {
    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    shareContractUrl = environment.apiUrl + '/share-contract'
    authUrl = environment.apiUrl + '/authentication'

    getShareDetails(resourceId: string, feature: SHARE_FEATURE) {
        return this.get<IShareContract>(this.shareContractUrl + '/', { resource: resourceId, feature })
    }

    getPermissionOfUser(resource: string, feature: SHARE_FEATURE) {
        return this.get<{
            canView: boolean,
            canEdit: boolean,
            canComment: boolean,
            restricted: boolean,
        }>(this.shareContractUrl + '/permission', { resource, feature })
    }


    getPermissionOfUserForWorkspace(resource: string, feature: SHARE_FEATURE) {
        return this.get<{
            canView: boolean,
            canEdit: boolean,
            canComment: boolean,
            restricted: boolean,
            accessSettings?: boolean,
            canEditWorkspace?: boolean,
        }>(this.shareContractUrl + '/workspace-permissions', { resource, feature })
    }

    addUserToShare(contract: string, user: Partial<IShareUser>, feature: SHARE_FEATURE = SHARE_FEATURE.CONTRACT) {
        return this.post<IShareContract>(this.shareContractUrl + '/user', { user, contract, feature })
    }

    authSharedContract(data: {
        contract: string,
        user: string
        share: string
    }) {
        return this.post(this.authUrl + '/share-auth', data)
    }

    verifyOtp(data: {
        contract: string, user: string, otp: string, share: string
    }) {
        return this.post<{ message: boolean, user?: IShareUser }>(this.authUrl + '/share-verify', data)
    }

    removeUserFromShare(contract: string, user: string, feature: SHARE_FEATURE = SHARE_FEATURE.CONTRACT) {
        return this.delete<IShareContract>(this.shareContractUrl + `/user/${contract}/${user}`, { feature })
    }

    updateShareUser(contract: string, user: IShareUser, feature: SHARE_FEATURE = SHARE_FEATURE.CONTRACT) {
        return this.put<IShareContract>(this.shareContractUrl + `/user`, {
            contract,
            user,
            feature
        })
    }

    updateAnyoneAccess(contract: string, access: SHARE_ACCESS) {
        return this.put<IShareContract>(this.shareContractUrl + `/anyone-access`, {
            contract,
            access
        })
    }

    updateShare(resource: string, share: any, feature: SHARE_FEATURE = SHARE_FEATURE.CONTRACT) {
        return this.put<IShareContract>(this.shareContractUrl + `/share`, {
            resource,
            share,
            feature
        })
    }

}